/**
 * Cementerio MCP — decoración: fragmentos de código muerto arrastrándose
 * detrás del contenido, con cadencia torpe de zombi (paradas irregulares,
 * ver @keyframes mcp-shamble en mcp-cemetery.css).
 *
 * MEJORA PROGRESIVA pura: las lápidas ya están en el HTML servido
 * (graveyard.blade.php). Esta capa es un <div> vacío
 * (.mcp-cemetery__field) que, sin JS, no pinta nada ni ocupa espacio --
 * position:absolute, sin contenido.
 *
 * prefers-reduced-motion: NO se crea ni un solo fragmento. La media query
 * en el CSS ya mata la animación por si acaso, pero aquí directamente no
 * hay nada que animar. Apagar la SECCIÓN con esta preferencia sería el
 * error que ya se cometió una vez con la constelación (ver
 * mcp-constellation.js) -- aquí ni se plantea, porque esta capa es 100%
 * decorativa: las lápidas viven fuera de ella, en .mcp-cemetery__content,
 * y no dependen de este script para nada.
 */
const FRAGMENTS = ['function()', '=> null', 'catch {}', '// TODO', 'return;', 'undefined'];
const COUNT = 12;

function boot(field) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const frag = document.createDocumentFragment();
    for (let i = 0; i < COUNT; i++) {
        const el = document.createElement('span');
        el.className = 'mcp-zombie';
        el.textContent = FRAGMENTS[i % FRAGMENTS.length];
        el.setAttribute('aria-hidden', 'true');
        // Reparte verticalmente con ruido, y cada uno con su propia
        // fase/duración -- así no caminan todos en fila como un desfile.
        const top = (i / COUNT) * 100 + (Math.random() * 5 - 2.5);
        el.style.top = Math.max(0, Math.min(96, top)) + '%';
        el.style.animationDelay = (Math.random() * 10).toFixed(2) + 's';
        el.style.animationDuration = (20 + Math.random() * 16).toFixed(2) + 's';
        frag.appendChild(el);
    }
    field.appendChild(frag);
    field.classList.add('is-animated');
}

document.querySelectorAll('[data-mcp-cemetery-field]').forEach(boot);
